import type { PositionWithAsset } from "types/Portfolio";

export const OPEN_POSITION_QUANTITY_EPSILON = 0.000001;

export function isOpenPortfolioPosition(position: Pick<PositionWithAsset, "quantity">): boolean {
    return Number(position.quantity) > OPEN_POSITION_QUANTITY_EPSILON;
}
